import"./Circle.css.ts.vanilla.css";var c="var(--_15usmcc1)",r="var(--_15usmcc0)",e="_15usmcc2",l="_15usmcc4",o="_15usmcc3";export{c as circleBgColor,r as circleColor,e as circleStyle,l as iconStyle,o as textStyle};
